<template>
  <div>
    <v-container style="padding-top: 80px;">
      <v-row justify="center">
        <v-col lg="6">
          <v-card flat class="bcg">
            <div class="pa-10">
              <form action="#" @submit.prevent="login">
                <h2>Login to TRADEinPOOL</h2>
                <span class="public-text">Welcome</span>

                <div class="register mt-6">
                  <v-text-field
                    v-model="email"
                    class="register mt-3"
                    label="Email"
                    background-color="#b6c1cb"
                    color="#4dbac0"
                    light
                    filled
                  ></v-text-field>
                  <v-text-field
                    v-model="password"
                    class="register mt-3"
                    label="Password"
                    background-color="#b6c1cb"
                    color="#4dbac0"
                    type="password"
                    light
                    filled
                  >
                    <template slot="append">
                      <v-icon v-if="capsDetected">keyboard_capslock</v-icon>
                    </template>
                  </v-text-field>
                </div>
                <span class="down">{{error}}</span>
                <div align="right">
                  <v-btn type="submit" large color="success" class="mt-3">
                    <v-icon>vpn_key</v-icon>
                    <span>Login</span>
                  </v-btn>
                </div>
              </form>
            </div>
          </v-card>
          <div lg="12" align="center" class="mt-4">
            Forgot your password?
            <router-link to="/lost">Recover</router-link>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <Footer />
  </div>
</template>

<script>
export default {
  name: "login",
  components: {},
  data() {
    return {
      loading: false,
      email: "",
      password: "",
      error: "",
      capsDetected: false
    };
  },
  methods: {
    login() {
      this.$store
        .dispatch("retrieveToken", {
          email: this.email,
          password: this.password
        })
        .then(() => {
          this.$router.push({ name: "Pool" });
        })
        .catch(() => {
          this.error = "Wrong email or password";
        });
    }
  },
  mounted() {
    var thisis = this;

    document.addEventListener("keyup", function(event) {
      // If "caps lock" is pressed, display the warning text
      if (event.getModifierState("CapsLock")) {
        thisis.capsDetected = true;
      } else {
        thisis.capsDetected = false;
      }
    });
    document.addEventListener("keydown", function(event) {
      // If "caps lock" is pressed, display the warning text
      if (event.getModifierState("CapsLock")) {
        thisis.capsDetected = true;
      } else {
        thisis.capsDetected = false;
      }
    });
  }
};
</script>

<style scoped>
.public-text {
  color: #b6c1ca !important;
}
.title-small {
  font-family: "Roboto";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 20px;
}
.bcg {
  background-image: url(../assets/img/logo-cropped.svg);
  background-size: contain;
}
</style>